import React, { useEffect } from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import FeatureSettingsContainer from "./FeatureSettingsContainer";

export default function () {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.FEATURE_SETTINGS],
  };

  return (
    <App
      isProtected={isProtected}
      checkRoles={checkRoles}
      showSidebar={true}
      adminHeader={true}
    >
      <FeatureSettingsContainer />
    </App>
  );
}
